import { useDevice } from "../context/DeviceContext";

// Wraps mobile-only views. In Desktop preview, renders a phone bezel; otherwise full screen.
export const MobileFrame = ({ children }) => {
  const { effectiveMode } = useDevice();

  if (process.env.NODE_ENV === "production") {
    return <div className="min-h-[100dvh] w-full m-0 bg-white">{children}</div>;
  }

  if (effectiveMode === "mobile") {
    return <div className="min-h-screen bg-honda-bg w-full">{children}</div>;
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-8">
      <div className="mobile-frame">
        <div className="mobile-scroll">{children}</div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-center text-gray-400 text-xs">
        <p className="font-semibold tracking-wider uppercase">SALES TRACK · Mobile PWA Preview</p>
        <p className="mt-1 text-gray-500">390 × 844 · Salesman View</p>
      </div>
    </div>
  );
};
